import React from 'react';
import { FormControlLabel, Grid, Typography } from '@mui/material';
import MultiSelectWithAll from '../../components/MultiSelectWithAll';
import { camelCaseToTitle } from '../../utils/caseConversion';
import { UserRole } from '../../enums';
import { rolesExcludedForParentsPostPublish } from './config/constants';
import { FormFieldSchema } from '../../components/FormRenderer/types';
import { Control, Controller } from 'react-hook-form';
import StyledCheckbox from '../common/styled/Checkbox';

const ParentPostPublishAccess = ({
  publishAccess,
  control
}: {
  publishAccess: FormFieldSchema;
  control: Control<any>;
}) => {
  const watch = control._getWatch;
  const formData = watch();
  const roleOptions = Object.entries(UserRole)
    .filter(
      ([_, value]) =>
        !rolesExcludedForParentsPostPublish.includes(value as UserRole)
    )
    .map(([_, value]) => ({
      label: camelCaseToTitle(value),
      value
    }));

  return (
    <Grid container spacing={2} alignItems='center'>
      {publishAccess.type === 'checkbox' && (
        <Grid size={{ xs: 12, sm: 3 }}>
          <Typography>
            {publishAccess.name ===
            'parentsPostPublishAccess.INDIVIDUAL.isEnabled'
              ? 'Individual'
              : 'Class Teachers'}
          </Typography>
        </Grid>
      )}
      {publishAccess.type === 'checkbox' && (
        <Grid size={{ xs: 12, sm: 3 }}>
          <Controller
            name={publishAccess.name}
            control={control}
            render={({ field, fieldState }) => (
              <FormControlLabel
                control={<StyledCheckbox {...field} checked={!!field.value} />}
                label='Enable'
              />
            )}
          />
        </Grid>
      )}
      {publishAccess.name === 'parentsPostPublishAccess.INDIVIDUAL.isEnabled' &&
        (formData.parentsPostPublishAccess?.INDIVIDUAL?.isEnabled || false) && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <Controller
              name={'parentsPostPublishAccess.INDIVIDUAL.allowedRoles'}
              control={control}
              render={({ field, fieldState }) => (
                <MultiSelectWithAll
                  label='Select Roles'
                  placeholder='Select Roles'
                  options={roleOptions}
                  selected={field.value ?? []}
                  onChange={field.onChange}
                />
              )}
            />
          </Grid>
        )}
    </Grid>
  );
};

export default ParentPostPublishAccess;
